import helper from "./helper";

let getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters
let getPassOrderUrlWithParameters = helper.getPassOrderUrlWithParameters
let getPlacesUrlWithParameters = helper.getPlacesUrlWithParameters

export default {
    SELECTORS: {
        USERS: {
            ALL: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|users",
                "get",
                {},
                gets
            ),
            VISITORS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|visitors",
                "get",
                {},
                gets
            )
        },
        CARS: {
            CARS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|cars",
                "get",
                {},
                gets
            ),
            MODELS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|cars|model",
                "get",
                {},
                gets
            )
        },
        VISITORS: {
            CARS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|visitor|cars",
                "get",
                null,
                gets
            ),
            ORGANIZATIONS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|organizations",
                "get",
                null,
                gets
            )
        },
        ORDERS: {
            FIELDS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|orders|fields",
                "get",
                null,
                gets
            ),
            ORGANIZATIONS: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|portal|organizations",
                "get",
                null,
                gets
            ),
            TERRITORIES: (parameters = {},gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|territories",
                "get",
                parameters,
                gets
            ),
            BUILDINGS: (parameters = {},gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|buildings",
                "get",
                parameters,
                gets
            ),
            ROOMS: (gets = null) => getPlacesUrlWithParameters(
                "selectors|core|rooms",
                "get",
                null,
                gets
            ),
            SUBORDINATES: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|subordinates",
                "get",
                null,
                gets
            )
        },
        POSTS: {
            NAMES: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|references|guard|post",
                "get",
                null,
                gets
            )
        },
        DEPARTMENTS: {
            ALL: (gets = null) => getPassOrderUrlWithParameters(
                "selectors|relations|departments",
                "get",
                null,
                gets
            )
        }
    }
}
